module.exports = __webpack_public_path__ + "img/orders-process.cd8daadd.svg";